module.exports = __webpack_public_path__ + "static/tnb-89d11883b6dc9a88cbd8c3731bc29b85.png";